import { render, staticRenderFns } from "./CustomerOperationalDocuments.vue?vue&type=template&id=5f022cb8"
import script from "./CustomerOperationalDocuments.vue?vue&type=script&lang=js"
export * from "./CustomerOperationalDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports